import styled from 'styled-components';

export default function AnniversaryLogo() {
    return (
        <BrandStyled aria-hidden="true">
            <span className="anniversary">20 años</span>
            <span className="caption">haciendo teatro</span>
        </BrandStyled>
    );
}

const BrandStyled = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.15em;
    color: var(--anniversary-text-color);
    font-family: 'Neuropol', sans-serif;
    font-weight: normal;
    line-height: 1.15;
    text-align: center;
    text-shadow: 0 1px 5px #000;

    .anniversary {
        color: var(--anniversary-brand-color);
        font-size: 1.3em;
    }

    .caption {
        font-size: 0.8em;
        white-space: nowrap;
    }
`;
